var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.367246 0.361771C0.59646 0.141242 0.903851 0.0207377 1.22187 0.0267381C1.53989 0.0327384 1.84251 0.164753 2.06325 0.393771L7.99925 6.69457L13.9352 0.393771C14.0431 0.274819 14.1738 0.178736 14.3195 0.111215C14.4652 0.0436931 14.623 0.00610759 14.7835 0.000684438C14.944 -0.00473872 15.104 0.0221106 15.2539 0.0796426C15.4039 0.137175 15.5408 0.224218 15.6564 0.335616C15.7721 0.447013 15.8643 0.580497 15.9274 0.728159C15.9906 0.875821 16.0234 1.03466 16.0241 1.19525C16.0247 1.35585 15.9931 1.51494 15.9311 1.6631C15.8691 1.81125 15.778 1.94546 15.6632 2.05777L8.86325 9.25777C8.75131 9.37391 8.6171 9.46629 8.46865 9.52938C8.3202 9.59248 8.16055 9.625 7.99925 9.625C7.83794 9.625 7.67829 9.59248 7.52984 9.52938C7.38139 9.46629 7.24719 9.37391 7.13525 9.25777L0.335246 2.05777C0.114718 1.82856 -0.00578654 1.52117 0.000213809 1.20315C0.00621416 0.885129 0.138229 0.582503 0.367246 0.361771Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackarrow);
export default __webpack_public_path__ + "static/media/blackarrow.81a769443d89977d33c0afbe64b5a0b4.svg";
export { ForwardRef as ReactComponent };